import { IViewData, TAuthenticationModalType } from 'shared/map-search/types/authenticationModal';
import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum ERequestAuthenticationActionType {
  Modal = 'requestAuthentication/modal',
}

export interface IPayload {
  type?: TAuthenticationModalType;
  viewData?: IViewData;
  source?: string;
}

type TRequestAuthenticationModal = ITypedReduxAction<ERequestAuthenticationActionType.Modal, IPayload>;

export type TRequestAuthenticationReduxActions = TRequestAuthenticationModal;
